<template>
  <div
    class="modal_overlay"
    v-if="visible"
    @click="handleOverlayClick"
  >
    <div
      class="modal_dialog"
      @click.stop
    >
      <h3 class="modal_title">更改密码</h3>
      <form
        class="password_form"
        @submit.prevent="handleSubmit"
      >
        <div class="form_group">
          <label class="form_label">现有密码*</label>
          <input
            type="password"
            class="form_input"
            v-model="currentPassword"
            required
            placeholder="请输入现有密码"
          />
        </div>
        <div class="form_group">
          <label class="form_label">新密码*</label>
          <input
            type="password"
            class="form_input"
            v-model="newPassword"
            required
            placeholder="请输入新密码"
            minlength="6"
          />
        </div>
        <div class="form_group">
          <label class="form_label">确认新密码*</label>
          <input
            type="password"
            class="form_input"
            v-model="confirmPassword"
            required
            placeholder="请确认新密码"
            minlength="6"
          />
          <span
            class="error_message"
            v-if="showPasswordError"
            >{{ passwordErrorMsg }}</span
          >
        </div>
        <div class="button_group">
          <button
            type="button"
            class="cancel_button"
            @click="handleCancel"
          >
            取消
          </button>
          <button
            type="submit"
            class="submit_button"
          >
            提交
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, watch } from "vue"
import md5 from "js-md5"

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
    default: false,
  },
})

const emits = defineEmits(["close", "confirm"])

const currentPassword = ref("")
const newPassword = ref("")
const confirmPassword = ref("")
const showPasswordError = ref(false)
const passwordErrorMsg = ref("")

// 监听密码输入变化，实时验证
watch([newPassword, confirmPassword], () => {
  if (newPassword.value && confirmPassword.value) {
    if (newPassword.value !== confirmPassword.value) {
      showPasswordError.value = true
      passwordErrorMsg.value = "两次输入的密码不一致"
    } else {
      showPasswordError.value = false
    }
  }
})

const handleSubmit = () => {
  // 表单验证
  if (!currentPassword.value) {
    alert("请输入现有密码")
    return
  }

  if (newPassword.value !== confirmPassword.value) {
    showPasswordError.value = true
    passwordErrorMsg.value = "两次输入的密码不一致"
    return
  }

  if (newPassword.value == currentPassword.value) {
    alert("现有密码与新密码相同，无需更改")
    return
  }

  // 提交密码修改请求
  emits("confirm", {
    oldPassword: md5(currentPassword.value),
    password: md5(newPassword.value),
  })

  // 重置表单
  resetForm()
}

const handleCancel = () => {
  resetForm()
  emits("close")
}

const handleOverlayClick = () => {
  handleCancel()
}

const resetForm = () => {
  currentPassword.value = ""
  newPassword.value = ""
  confirmPassword.value = ""
  showPasswordError.value = false
}
</script>

<style scoped>
.modal_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal_dialog {
  background-color: #ffffff;
  border-radius: 8px;
  width: 30vw;
  padding: 2vw;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.modal_title {
  color: #333333;
  font-size: 1.25vw;
  font-weight: 600;
  margin-bottom: 1.5vw;
  text-align: center;
}

.form_group {
  margin-bottom: 1vw;
}

.form_label {
  display: block;
  color: #666666;
  font-size: 1vw;
  margin-bottom: 0.5vw;
}

.form_input {
  width: 100%;
  padding: 0.75vw;
  border: 1px solid #dddddd;
  border-radius: 4px;
  font-size: 1vw;
  box-sizing: border-box;
}

.form_input:focus {
  outline: none;
  border-color: #409eff;
}

.error_message {
  color: #ff4d4f;
  font-size: 0.875vw;
  margin-top: 0.25vw;
  display: block;
}

.button_group {
  display: flex;
  justify-content: flex-end;
  gap: 1vw;
  margin-top: 1.5vw;
}

.cancel_button {
  padding: 0.5vw 1.5vw;
  border: 1px solid #dddddd;
  background-color: #ffffff;
  color: #666666;
  border-radius: 4px;
  font-size: 1vw;
  cursor: pointer;
  transition: all 0.2s;
}

.cancel_button:hover {
  background-color: #f5f5f5;
}

.submit_button {
  padding: 0.5vw 1.5vw;
  border: none;
  background-color: #409eff;
  color: #ffffff;
  border-radius: 4px;
  font-size: 1vw;
  cursor: pointer;
  transition: all 0.2s;
}

.submit_button:hover {
  background-color: #337ecc;
}
</style>
